// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_navWrapper__4WjTw {
  width: 100%;
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/components/pageNav/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,kDAAA;AADF","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.navWrapper {\n  width: 100%;\n  display: flex;\n  border-bottom: 1px solid $white-5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navWrapper": `styles_navWrapper__4WjTw`
};
export default ___CSS_LOADER_EXPORT___;
